import AssignmentDetails from "../../fragments/assignment-details";
import BackButton from "../../util/back-button";


function EmployeeAssignmentDetails({ employeeId, subpage }) {
  return <>
      <BackButton />
      <AssignmentDetails id={subpage} preselectedEmployeeId={employeeId} />  
  </>
}

export default EmployeeAssignmentDetails